export const ROUTER = {
    DATA_CATALOG: {
        DEFAULT: '/data-catalog',
        METADATA: '/data-catalog/metedata',
        DATASOURCE: '/data-catalog/data-source',
        MANAGE_INGESTION: '/data-catalog/manage-ingestion',
    },
    DS_INVENTORY: {
        DEFAULT: '/ds-inventory',
        DASHBOARD: '/ds-inventory/dashboard',
        DATAFLOW: '/ds-inventory/data-flow',
        ROPA: '/ds-inventory/ropa',
    },
    DS_360: {
        DEFAULT: '/ds-360',
        DASHBOARD: '/ds-360/dashboard',
        MY_TASK: '/ds-360/my-task',
        DS_REQUEST_FORM: '/ds-360/ds-request-form',
        WORKFLOW: '/ds-360/workflow',
        IMPORT_DS_REQUEST: '/ds-360/import-ds-request',
    },
    RISK_MANAGEMENT: {
        DEFAULT: '/risk-management',
        DASHBOARD: '/risk-management/dashboard',
        RA: '/risk-management/risk-assessment',
        RR: '/risk-management/risk-register',
    },
    COOKIE_MANAGEMENT: {
        DEFAULT: '/cookie-management',
        DASHBOARD: '/cookie-management/dashboard',
        COOKIE_SCANNER: '/cookie-management/cookie-scanner',
        COOKIE_CATEGORY: '/cookie-management/cookie-category',
        CUSTOMIZE_BANNER: '/cookie-management/customize-banner',
    },
    POLICY: {
        DEFAULT: '/policy',
        PRIVACY_NOTICES: '/policy/privacy-policy',
        HR_PRIVACY: '/policy/hr-policy',
        VENDOR_PRIVACY: '/policy/vendor-policy',
        COOKIE_PRIVACY: '/policy/cookie-policy',
        CCTV_PRIVACY: '/policy/cctv-policy',
        RECRUITMENT_PRIVACY: '/policy/recruitment-policy',
        DPA: '/policy/dpa',
        HISTORY: '/policy/history',
        FREE_FORM: '/policy/free-form',
    },
    CONSENT_MANAGEMENT: {
        DEFAULT: '/consent-management',
        DASHBOARD: '/consent-management/dashboard',
        CONSENT: '/consent-management/consent',
        TEMPLATE_DESIGN: '/consent-management/template-design',
        MANANGE_CONSENT: '/consent-management/manage-consent',
        IMPORT_CONSENT: '/consent-management/import-consent',
    },
    CONFIGURATION: {
        DEFAULT: '/configuration',
        USER_MANAGEMENT: '/configuration/user-management',
        DC_DPO: '/configuration/dc-dpo',
        DATA_CATALOG: '/configuration/data-catalog',
        UPGRADE_PLAN: '/configuration/upgrade-plan',
        EMAIL_SETTING: '/configuration/email-setting',
        YOUR_PLAN: '/configuration/your-plan',
        PERMISSION: '/configuration/permission',
    },
    DPIA: {
        DEFAULT: '/dpia',
    },
    DATA_INQUIRY: {
        DEFAULT: '/data-inquiry',
    },
    REPORT: {
        DEFAULT: '/report',
    },
    DATA_BREACH: {
        DEFAULT: '/data-breach',
        DASHBOARD: '/data-breach/dashboard',
        LOG: '/data-breach/log',
        LOG_FORM: '/data-breach/log/form',
        FORM: '/data-breach/form',
        EDIT_FORM: '/data-breach/form/:id',
        REPORT: '/data-breach/report',
        VIEW: '/form/data-breach/:id',
        RESPONSIBILITY: '/data-breach/responsibility',
        RESPONSIBILITY_FORM: '/data-breach/responsibility/form',
    },
    USER_NOT_FOUND: '/user-not-found',
};
